// TOUR-4a — portaled teaching firefly while flying between tour anchors.

import { Firefly } from "./Firefly";
import { FireflyViewportPortal } from "./FireflyViewportPortal";
import type { FireflyIntent } from "./fireflyIntents";
import { FIREFLY_TOUR_BUG_Z } from "@/lib/firefly/fireflyTourLayerZIndex";

export function FireflyTourTravelFirefly(props: {
  viewportX: number;
  viewportY: number;
  intent: Extract<FireflyIntent, "teaching" | "discovery" | "guidance">;
}) {
  const { viewportX, viewportY, intent } = props;

  return (
    <FireflyViewportPortal
      viewportX={viewportX}
      viewportY={viewportY}
      smoothTransition={false}
      zIndex={FIREFLY_TOUR_BUG_Z}
    >
      <Firefly
        intent={intent}
        anchorX={0}
        anchorY={0}
        highlightGeneration={0}
        highlightX={0}
        highlightY={0}
        dragChasing
        ambientHover={false}
        blinkingSuppressed
      />
    </FireflyViewportPortal>
  );
}
